import { Image } from 'react-native';

import {
	ActiveTablesBtn,
	BgLandscapePng,
	BgPortraitPng,
	BgTournament,
	BgTournamentMobile,
	BlueButton,
	BottomButtons,
	BronzeButton,
	BronzeTournamentCard,
	BtnCloseModal,
	BtnMainPlayNowPng,
	BtnMainTournamentsPng,
	BtnMainVipPng,
	BtnSidebarClosePng,
	buyNowChips,
	chipImgOne,
	ChipsBackgrOne,
	ChipsBackgrOneLand,
	CityPng,
	DailyBonusBgGif,
	DailyBonusEnGif,
	DailyBonusFrGif,
	DailyBonusRuGif,
	EntryChipsIcon,
	FirstCup,
	GoldButton,
	goldChipIcon,
	GoldTournamentCard,
	LeftArrowPng,
	LightBtn,
	LightsLevels,
	LockedTournament,
	MainBtnMobile,
	mainLobbyBtn,
	mainLobbyBtnActive,
	mainLobbyBtnDesktop,
	Num0Png,
	Num1Png,
	Num2Png,
	Num3Png,
	Num4Png,
	Num5Png,
	Num6Png,
	Num7Png,
	Num8Png,
	Num9Png,
	PlayerLogo,
	ProfileChipPng,
	Rank1Logo,
	Rank2Logo,
	Rank3Logo,
	RankBgr1,
	RankBgr2,
	RankBgr3,
	RankBgrRegular,
	RankChip,
	RankExp,
	RankingTabBtn,
	RankingTabBtnSelected,
	RankLevelBorder,
	RankNameBorder,
	RankPlayerLogoBorder,
	RankStarLight,
	RewardChips,
	RewardsBlueLight,
	RewardsBronzeLight,
	RewardsPurpleLight,
	RightArrowPng,
	SidebarBackgroundPng,
	SilverTournamentCard,
	SmallVipSix,
	TablesContainerPng,
	Timer,
	TournamentChipsIcon,
	TournamentsChipImg,
	TournamentWinCoins,
	TropheeBronze,
	TropheeGold,
	TropheeSilver,
	UnderTitleLight,
	WinButton,
} from '../assets';
import { VipTicketPng } from '../assets/bonuses';

//  ------------- ASSET PRELOAD REGISTRY -------------
//   Keep this file simple:
//   - Group assets by user-facing FEATURE, not by file type
//   - Add only assets visible IMMEDIATELY when that feature opens.
//   - Prefer `boot` only for shell/core UI that is effectively always available!
//   - For feature UI (modals/screens), add a group and preload it from route entry
//     points or `onPressIn` on the button that opens it.
//  ---------------------------------------------------

type ImageAsset = number | string | { uri?: string };

type PreloadGroup = {
	images?: ImageAsset[];
	webRequests?: string[];
};

type RouteName =
	| 'Main'
	| 'Lobby'
	| 'Room'
	| 'BuyPackages'
	| 'Ranking'
	| 'Tournaments'
	| 'Tournament'
	| 'ActiveTournament'
	| 'Profile'
	| 'Settings'
	| 'Help';

export type PreloadGroupName =
	| 'boot'
	| 'home'
	| 'buyChips'
	| 'lobby'
	| 'ranking'
	| 'dailyBonus'
	| 'bonuses'
	| 'login'
	| 'tournaments';

const isWebRuntime = typeof document !== 'undefined';
const preloadedGroups = new Set<PreloadGroupName>();
const preloadedImageUris = new Set<string>();
const preloadedUrls = new Set<string>();

const HOME_SPINE_TEXTURE = '/spine/home-page/UI_CTA_MAIN_BUTTONS.webp';
const HOME_PLAY_NOW_SPINE_TEXTURE = '/spine/home-page/playnow_button.png';
const LOBBY_SPINE_TEXTURE = '/spine/cities/CITY.webp';
const LOGO_SPINE_TEXTURE = '/spine/logo/LOGO_ANIM.webp';
const LOADER_SPINE_TEXTURE = '/spine/loader/LOADER.png';

/**
 * Add assets here when a feature is visually slow on first open.
 *
 * Tips:
 * - Put local png/svg/gif/etc. assets in `images`
 * - Put web-only fetchable URLs in `webRequests`
 * - Keep groups small and focused on first-visible content
 * - GIFs can be preloaded too, but be careful with large files because they can add unnecessary startup cost
 */
const PRELOAD_GROUPS: Record<PreloadGroupName, PreloadGroup> = {
	boot: {
		images: [
			BgLandscapePng,
			BgPortraitPng,
			BgTournament,
			BgTournamentMobile,
			SidebarBackgroundPng,
			BtnSidebarClosePng,
			// Daily bonus collect overlay: localized GIFs (one shown based on language)
			DailyBonusBgGif,
			DailyBonusEnGif,
			DailyBonusFrGif,
			DailyBonusRuGif,
			// Digit PNGs used to render the collected chip amount
			Num0Png,
			Num1Png,
			Num2Png,
			Num3Png,
			Num4Png,
			Num5Png,
			Num6Png,
			Num7Png,
			Num8Png,
			Num9Png,
		],
	},
	home: {
		images: [BtnMainVipPng, BtnMainPlayNowPng, BtnMainTournamentsPng],
		webRequests: [
			'/spine/home-page/playnow_button.json',
			'/spine/home-page/playnow_button.atlas',
			HOME_PLAY_NOW_SPINE_TEXTURE,
			'/spine/home-page/UI_CTA_PLAYNOW.json',
			'/spine/home-page/UI_CTA_VIP.json',
			'/spine/home-page/UI_CTA_TOURNAMENTS.json',
			'/spine/home-page/UI_CTA_MAIN_BUTTONS.atlas',
			HOME_SPINE_TEXTURE,
		],
	},
	buyChips: {
		images: [
			BottomButtons,
			BtnCloseModal,
			LightBtn,
			ProfileChipPng,
			SmallVipSix,
			buyNowChips,
			ChipsBackgrOne,
			ChipsBackgrOneLand,
			chipImgOne,
			goldChipIcon,
			UnderTitleLight,
		],
	},
	lobby: {
		images: [CityPng, TablesContainerPng, LightsLevels],
		webRequests: ['/spine/cities/CITY.json', '/spine/cities/CITY.atlas', LOBBY_SPINE_TEXTURE],
	},
	ranking: {
		images: [
			BtnCloseModal,
			RankingTabBtn,
			RankingTabBtnSelected,
			PlayerLogo,
			Rank1Logo,
			Rank2Logo,
			Rank3Logo,
			RankBgr1,
			RankBgr2,
			RankBgr3,
			RankBgrRegular,
			RankChip,
			RankExp,
			RankLevelBorder,
			RankNameBorder,
			RankPlayerLogoBorder,
			RankStarLight,
			FirstCup,
			Timer,
		],
	},
	dailyBonus: {
		images: [
			// Localized bonus GIFs (one shown based on language)
			DailyBonusBgGif,
			DailyBonusEnGif,
			DailyBonusFrGif,
			DailyBonusRuGif,
			// Digit PNGs used to render the collected chip amount
			Num0Png,
			Num1Png,
			Num2Png,
			Num3Png,
			Num4Png,
			Num5Png,
			Num6Png,
			Num7Png,
			Num8Png,
			Num9Png,
		],
	},
	// The VIP Ticket beside the VIP Arcade info button, which otherwise only starts loading once
	// the balance has arrived and the badge mounts.
	bonuses: {
		images: [VipTicketPng],
	},
	login: {
		webRequests: [
			'/spine/logo/LOGO.json',
			'/spine/logo/LOGO_ANIM.atlas',
			LOGO_SPINE_TEXTURE,
			'/spine/loader/LOADER.json',
			'/spine/loader/LOADER.atlas',
			LOADER_SPINE_TEXTURE,
		],
	},
	tournaments: {
		images: [
			// Tournament card backgrounds
			BronzeTournamentCard,
			SilverTournamentCard,
			GoldTournamentCard,
			// Tournament card overlays & buttons
			LockedTournament,
			ActiveTablesBtn,
			TournamentsChipImg,
			TournamentWinCoins,
			BronzeButton,
			WinButton,
			GoldButton,
			// Tournament details screen
			BlueButton,
			TournamentChipsIcon,
			EntryChipsIcon,
			TropheeGold,
			TropheeSilver,
			TropheeBronze,
			RewardsBlueLight,
			RewardsBronzeLight,
			RewardsPurpleLight,
			RewardChips,
			// Bottom navigation bar (tournament-specific)
			mainLobbyBtn,
			mainLobbyBtnActive,
			mainLobbyBtnDesktop,
			MainBtnMobile,
			// Carousel arrows
			LeftArrowPng,
			RightArrowPng,
		],
	},
};

const getAssetUri = (asset: ImageAsset): string | undefined => {
	if (typeof asset === 'string') {
		return asset;
	}

	if (asset && typeof asset === 'object' && 'uri' in asset && typeof asset.uri === 'string') {
		return asset.uri;
	}

	const resolveAssetSource = (
		Image as {
			resolveAssetSource?: (source: ImageAsset) => { uri?: string };
		}
	).resolveAssetSource;

	return resolveAssetSource?.(asset)?.uri;
};

const preloadImage = (asset: ImageAsset) => {
	const uri = getAssetUri(asset);
	if (!uri || preloadedImageUris.has(uri)) {
		return;
	}

	preloadedImageUris.add(uri);

	if (isWebRuntime) {
		const image = new globalThis.Image();
		image.decoding = 'async';
		image.src = uri;
		return;
	}

	Image.prefetch(uri).catch(() => {});
};

const preloadWebUrl = (url: string) => {
	if (!isWebRuntime || !url || preloadedUrls.has(url) || typeof fetch === 'undefined') {
		return;
	}

	preloadedUrls.add(url);
	fetch(url, { cache: 'force-cache' }).catch(() => {});
};

/**
 * Preload one feature group once.

 * Safe to call multiple times; repeated calls are ignored after the first run.
 */
export const preloadGroup = (groupName: PreloadGroupName) => {
	if (preloadedGroups.has(groupName)) {
		return;
	}

	preloadedGroups.add(groupName);

	const group = PRELOAD_GROUPS[groupName];
	group.images?.forEach(preloadImage);
	group.webRequests?.forEach(preloadWebUrl);
};

/**
 * Startup preload for assets that should be ready very early.
 */
export const preloadCriticalAssets = () => {
	preloadGroup('boot');
	preloadGroup('home');
	preloadGroup('dailyBonus');
	preloadGroup('login');
};

/**
 * Route-based preload rules.
 *
 * Update this when a route has a clear "likely next action" that opens a heavy
 * modal/screen and should feel faster on first use.
 */
export const preloadForRoute = (routeName?: string) => {
	const route = routeName as RouteName | undefined;

	if (route === 'Main') {
		preloadGroup('home');
		preloadGroup('buyChips');
		preloadGroup('lobby');
		preloadGroup('ranking');
		preloadGroup('bonuses');
		return;
	}

	if (route === 'Lobby' || route === 'Room') {
		preloadGroup('lobby');
		preloadGroup('buyChips');
		preloadGroup('ranking');
		return;
	}

	if (route === 'BuyPackages') {
		preloadGroup('buyChips');
		return;
	}

	if (route === 'Ranking') {
		preloadGroup('ranking');
		return;
	}

	if (route === 'Tournaments' || route === 'Tournament' || route === 'ActiveTournament') {
		preloadGroup('tournaments');
		preloadGroup('buyChips');
		preloadGroup('ranking');
		return;
	}
};
